'use client';

import { Box } from '@mui/material';

import { EmptyState } from '@/components/common';
import { SportsPropsSkeleton } from '@/components/skeletons';
import { MarketCardList } from '@/components/specific/pages/home';
import { useT } from '@/hooks';
import { EventResponse } from '@/types';

interface SportPropsViewProps {
  props: EventResponse[];
  isLoading?: boolean;
  onPropTradeClick: (propId: string, outcomeId: string, isBuy: boolean) => void;
}

export const SportPropsView = ({ props, isLoading, onPropTradeClick }: SportPropsViewProps) => {
  const { t } = useT();

  if (isLoading) {
    return <SportsPropsSkeleton />;
  }

  if (!props || props.length === 0) {
    return (
      <EmptyState
        title={t('sports.noPropsAvailable', { defaultValue: 'No props available' })}
        description={t('sports.noPropsAvailableDesc', {
          defaultValue: 'Try selecting a different category or check back later.',
        })}
      />
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
          lg: 'repeat(3, 1fr)',
        },
        gap: 2,
      }}
    >
      <MarketCardList events={props} onTradeClick={onPropTradeClick} />
    </Box>
  );
};
